import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
  height?: string | number;
  width?: string | number;
  showBackground?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading data...',
  size = 40,
  height = '200px',
  width = '100%',
  showBackground = true,
}) => {
  return (
    <Box
      sx={{
        height,
        width,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        background: showBackground ? '#f8f9fa' : 'transparent',
        borderRadius: showBackground ? '8px' : '0',
        border: showBackground ? '1px solid #e9ecef' : 'none',
      }}
    >
      <CircularProgress 
        size={size} 
        sx={{ 
          color: '#7800F0',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          },
        }} 
      />
      <Typography
        variant="body2"
        sx={{
          color: '#6b7280',
          fontSize: '14px',
          fontWeight: 500,
          textAlign: 'center',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}; 